module.exports = function(str){
    return str.length?
            str.charAt(0).toLowerCase() + str.substring(1):
            str
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/toLowerFirst.js
 ** module id = 822
 ** module chunks = 0
 **/